module.exports = __webpack_public_path__ + "fk.12d25ef6aeae7d25bee1.svg";


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/sm8-v1-front/src/scss/icons/flag-icon-css/flags/fk.svg
// module id = ../../../../../src/scss/icons/flag-icon-css/flags/fk.svg
// module chunks = styles